module.exports = __webpack_public_path__ + "static/media/hana.a2ad5b20.jpeg";